const FromTemplate = () => {
    return(
        <div>

        </div>
    )
}

export default FromTemplate;